import React, {Component} from 'react'
import {FormattedMessage, FormattedDate} from 'react-intl'
import Icon from "../icon/icon.component.jsx"

class TemplateHeader extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            variables: this.props.value || null,
            isPdf: this.props.isPdf || false,
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            variables: nextProps.value || null,
            isPdf: nextProps.isPdf || false,
        })
    }

    render() {
        if (!this.state.variables) {
            return <div />
        }

        let logo = <h1>{this.state.variables.company.name}</h1>
        if (this.state.variables.company.logoUrl && !this.state.isPdf) {
            logo = <p>
                <img src={this.state.variables.company.logoUrl} style={{
                    maxHeight: '100px',
                    maxWidth: '300px',
                }}/>
            </p>
        }

        let pdfDownloadButton = ''
        if (!this.state.isPdf) {
            pdfDownloadButton = <p>
                <a className="btn btn-secondary btn-sm" href={this.state.variables.document.pdfUri} target="_blank">
                    <Icon value={"file-pdf"}/>
                    <FormattedMessage
                        id="proposal.items.quote_download_btn"
                        defaultMessage="Download"
                    />
                </a>
            </p>
        }

        const containerClass = !this.state.isPdf ? 'col-md-10 col-sm-12 ui-module-proposal' : 'col-12'
        return <div className={containerClass}>
            <div className="row">
                <div className="col-12 text-center">
                    {logo}
                    <hr/>
                </div>
                <div className="col-12 text-left">
                    <div className="row">
                        <div className="col-md-4 col-sm-12">
                            <p>
                                <strong>
                                    <FormattedMessage
                                        id="templates.header.from_label"
                                        defaultMessage="From"
                                    /> :</strong> {this.state.variables.seller.name}
                                <br/>
                                {this.state.variables.company.address.street}<br/>
                                {this.state.variables.company.address.postalCode} - {this.state.variables.company.address.city}<br/>
                                {this.state.variables.company.address.state}, {this.state.variables.company.address.country}<br/>
                                {this.state.variables.company.phoneNumber}<br/>
                                <a href={'mailto:' + this.state.variables.seller.email}>{this.state.variables.seller.email}</a>
                            </p>
                        </div>
                        <div className="col-md-4 col-sm-12 border-left">
                            <p>
                                <strong>
                                    <FormattedMessage
                                        id="templates.header.to_label"
                                        defaultMessage="To"
                                    /> :</strong> {this.state.variables.customer.name}<br/>
                                {this.state.variables.customer.address.street}<br/>
                                {this.state.variables.customer.address.postalCode} - {this.state.variables.customer.address.city}<br/>
                                {this.state.variables.customer.address.state}, {this.state.variables.customer.address.country}<br/>
                                {this.state.variables.customer.phoneNumber}<br/>
                            </p>
                        </div>
                        <div className="col-md-4 col-sm-12 border-left">
                            <p>
                                <strong>
                                    <FormattedMessage
                                        id="proposal.items.quote_reference"
                                        defaultMessage="Reference"
                                    />
                                    :</strong> {this.state.variables.document.reference}<br/>
                                <strong>
                                    <FormattedMessage
                                        id="proposal.items.quote_date"
                                        defaultMessage="Date"
                                    />
                                    :&nbsp;
                                </strong>
                                <FormattedDate
                                    year='numeric'
                                    month='long'
                                    day='numeric'
                                    value={
                                        this.state.variables.document.date ?
                                            new Date(this.state.variables.document.date) :
                                            new Date()
                                    }/>
                                <br/>
                            </p>
                            {pdfDownloadButton}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    }

}

export default TemplateHeader





// WEBPACK FOOTER //
// ./src/common/template/header.component.jsx